/* eslint-disable */
require('../components/spinner');
require('../components/loader');

import highlightlabels from '../components/highlightLabels';
import Validator from '../components/clientSideValidationCheckout';
import { updateUrl as modifyUrl } from '../searchHelpers';
import { loadFormErrors } from './formErrors';
import { openTabs, appendToUrl } from '../util';
import {
    pushOriginalLocation,
    pushPageView,
    pushPersonalInformationEvent,
    pushAddToCartEvent,
    pushRemoveFromCartEvent,
    pushPaymentMethodEvent,
    pushErrorEvent,
    pushSelectClubEvent,
    pushMembershipStepCTAEvent,
    pushViewTypeSelectEvent,
    pushMembershipViewDetailsEvent,
    pushMembershipHideDetailsEvent,
    pushSelectAddonEvent,
    pushSelectFilterEvent,
} from './../gtm/checkoutFlow';
import adyenDropin from './adyenDropin';
import { MembershipTiles, equalizeTiles } from '../membershipTilesSwiper';
import MapboxCheckout from './mapboxCheckout';
import {
    getSelectedFilters,
    promotionLabelTooltip,
    infoTooltipModal,
    searchStores,
    closeMapModal,
    checkoutLocation,
} from './homeClubHelpers';
import {
    updateMembershipBlock,
    handleMembershipSelection,
    handleRedirectFromCDP,
    getPreselectedMembershipInfo,
    countdown,
} from './membershipHelpers';
import {
    toggleDropinButtons,
    updateMembershipDuration
} from './paymentMethodHelpers';
import {
    initSummaryAccordion,
    showSummary,
    toggleMobileSummary,
    bindOrderSummaryToggleTouchDevices,
    bindOrderSummaryLowEntryBarrierPopup,
    updateMiniCart
} from './orderSummary';

/**
 * Create the jQuery Checkout Plugin.
 *
 * This jQuery plugin will be registered on the dom element in checkout.isml with the
 * id of "checkout-main".
 *
 * The checkout plugin will handle the different state the user interface is in as the user
 * progresses through the varying forms such as shipping and payment.
 *
 * Billing info and payment info are used a bit synonymously in this code.
 *
 */
(function checkoutPlugin($) {
    $.fn.checkout = function checkout() { // eslint-disable-line no-param-reassign
        const plugin = this;

        // Collect form data from user input
        const formData = {
            // Shipping Address
            shipping: {},
            // Billing Address
            billing: {},
            // Payment
            payment: {},
        };

        // The different states/stages of new checkout flow
        const checkoutStages = [
            'HomeClub',
            'Membership',
            'AddOns',
            'PersonalInformation',
            'PaymentMethod'
        ];

        let isStep3 = 0;
        let isStep2 = 0;

        const laptopMaxWidth = 1025;
        const mobileMaxWidth = 768;

        /**
         * Try another location
         */
        function tryAnotherLocation() {
            $('.js-try-another-location').on('click', (e) => {
                e.stopPropagation();
                $('.js-search-input').trigger('focus');
                $('.js-search-input').val('');
            });
        }
        tryAnotherLocation();

        /**
         * @description Close mobile keyboard on keyboard search icon/button click
         * @param {element} input element selector
         */
        function hideMobileKeyboardOnReturn(element) {
            $(element).on('keyup', (keyboardEvent) => {
                const key = keyboardEvent.code || keyboardEvent.keyCode;
                if (key === 'Enter' || key === 13) {
                    $(element).blur();
                }
            });
        }

        /**
        * loop through the tabs and disable all after the current active tab
        */
        function disableFutureSteps(activeItemId = 0) {
            let futureTab = 0;
            $('.js-choose-step-tab').each(function() {
                $(this).removeClass('disable-step');
                // if we (re)loaded the page we get the active tab from the 'activeItemId' and use it here and set the active tab
                if($(this).attr('data-stage') == activeItemId) {
                    $(this).addClass('active');
                    futureTab = 1;
                    // else we must get the active tab from tab class:
                } else if($(this).hasClass('active')) {
                    futureTab = 1;
                } else if(futureTab === 1) {
                    $(this).addClass('disable-step');
                }
            });
        }

        /**
        * @description animation to steps
        * @param {string} datastage - stage to animate to
        */
        function stepAnimation(datastage) {
            $('html, body').stop().animate({
                scrollTop: $('.js-choose-step-tab[data-stage="' + datastage + '"]').offset().top,
            }, 500);
        }

        // eslint-disable-next-line valid-jsdoc
        /**
         * Function for creating club address summary for step 1
         * @param {string} address1
         * @param {string} address2
         * @returns dom element
         */
        function createStepOneClubSummary(address1, address2) {
            const $clubSummaryData = `
                <div class="properties">
                    <p class="street">
                        ${address1} ${address2}
                    </p>
                </div>`;
            return $clubSummaryData;
        }

        /**
         * Toggles payment methods buttons based on the state of the Step 5 checkout input fields
         */
        function handleDropinButtons() {
            const dropinMutationObserver = new MutationObserver(() => {
                const $paymentMethods = [
                    $('.adyen-checkout__payment-method--credit'),
                    $('.adyen-checkout__payment-method--paypal'),
                    $('.adyen-checkout__payment-method--applepay'),
                    $('.adyen-checkout__payment-method--bizum'),
                    $('.adyen-checkout__payment-method--ideal'),
                    $('.adyen-checkout__payment-method--directEbanking'),
                    $('.adyen-checkout__payment-method--bcmc')
                ];
                const isExist = $paymentMethods.some(($paymentMethod) => $paymentMethod.length > 0);
                const isValid = $paymentMethods.some(($paymentMethod) => $paymentMethod.hasClass('adyen-checkout__payment-method--selected'));

                if (isExist) {
                    const $accountHolder = $('#dwfrm_paymentDetails_accountHolder');
                    const $accountNumber = $('#dwfrm_paymentDetails_accountNumber');
                    const $sepaAgreement = $('#dwfrm_paymentDetails_agreeAutomaticSEPA');
                    const $termsAndConditions = $('#termsAndConditionsCheck');

                    if (isValid) {
                        toggleDropinButtons($paymentMethods);
                    }

                    if ($accountHolder) {
                        $accountHolder.on('keyup', () => toggleDropinButtons($paymentMethods));
                    }
                    if ($accountNumber) {
                        $accountNumber.on('keyup', () => toggleDropinButtons($paymentMethods));
                    }
                    if ($sepaAgreement) {
                        $sepaAgreement.on('change', () => {
                            $sepaAgreement.valid();
                            toggleDropinButtons($paymentMethods);
                        });
                    }
                    if ($termsAndConditions) {
                        $termsAndConditions.on('change', () => {
                            $termsAndConditions.valid();
                            toggleDropinButtons($paymentMethods);
                        });
                    }
                }
            });

            dropinMutationObserver.observe(document.getElementById('dropin-container'), { childList: true, subtree: true });
        }

        /**
         * Handles external email validation and auto complete email suggestions on checkout step 4
         */
        const handleEmailValidation = () => {
            const $emailValidation = $('.js-email-validation');
            const $emailConfirmCheckbox = $('.js-email-confirm-checkbox');

            if ($emailValidation.length < 1) {
                return;
            }

            let timeout;
            let skipBlur = false;
            const DEFAULT_INVALID_CLASS = 'is-invalid';
            const EMAIL_VALIDATION_INVALID_CLASS = 'is-email-validation-invalid';
            const $emailInput = $emailValidation.find('input');
            const $emailInvalidFeedback = $emailValidation.find('.invalid-feedback');
            const $emailValidationInvalidFeedback = $emailValidation.find('.invalid-email-validation-feedback');
            const url = $emailValidation.attr('data-email-validation-url');

            /**
             * Renders validation errors
             */
            const addEmailValidationErrors = (data) => {
                $emailInput.addClass(data.errorClass);

                if (data.errorClass === DEFAULT_INVALID_CLASS) {
                    $emailInput.removeClass(EMAIL_VALIDATION_INVALID_CLASS);
                    $emailValidationInvalidFeedback.html('');
                    $emailInvalidFeedback.html(data.errorMessage);
                } else if (data.errorClass === EMAIL_VALIDATION_INVALID_CLASS) {
                    $emailInput.removeClass(DEFAULT_INVALID_CLASS);
                    $emailInvalidFeedback.html('');
                    $emailValidationInvalidFeedback.html(data.errorMessage);
                }
            };

            /**
             * Removes validation errors
             */
            const clearEmailValidationErrors = () => {
                $emailInput.removeClass(`${DEFAULT_INVALID_CLASS} ${EMAIL_VALIDATION_INVALID_CLASS}`);
                $emailInvalidFeedback.html('');
                $emailValidationInvalidFeedback.html('');
            };

            /**
             * Removes auto complete
             */
            const clearAutoComplete = () => {
                const $autoCompleteEmailList = $emailValidation.find('.js-auto-complete-email-list');
                $autoCompleteEmailList.remove();
            };

            /**
             * Validates given email by sending AJAX request
             * @param {string} email - Email address
             */
            const triggerEmailValidation = (email) => {
                $.ajax({
                    url: appendToUrl(url, { email }),
                    type: 'GET',
                    dataType: 'json',
                    success: (data) => {
                        if (!data.valid) {
                            addEmailValidationErrors(data);
                        } else {
                            clearEmailValidationErrors();
                        }
                    },
                    error: () => {
                        clearAutoComplete();
                        clearEmailValidationErrors();
                    },
                });
            };

            $emailInput.on('keyup', (e) => {
                clearTimeout(timeout);

                timeout = setTimeout(() => {
                    const code = e.key;
                    const email = $emailInput.val();
                    const isEmailValidation = email.length >= 2 && ($emailInput.hasClass(DEFAULT_INVALID_CLASS) || $emailInput.hasClass(EMAIL_VALIDATION_INVALID_CLASS));
                    const isEmailValidationEmpty = email.length < 1;
                    const isAutoComplete = /@.+/.test(email);

                    if (isEmailValidationEmpty) {
                        $emailInput.removeClass(`${EMAIL_VALIDATION_INVALID_CLASS}`);
                        $emailValidationInvalidFeedback.html('');
                    }

                    if (code === 'Enter') {
                        clearAutoComplete();
                        return;
                    }

                    if (!isAutoComplete) {
                        clearAutoComplete();
                    }

                    if (!isEmailValidation && !isAutoComplete) {
                        return;
                    }

                    $.ajax({
                        url: appendToUrl(url, { email }),
                        type: 'GET',
                        dataType: 'json',
                        success: (data) => {
                            clearAutoComplete();

                            if (data.autoCompleteHtml) {
                                $(data.autoCompleteHtml).insertAfter($emailInput);
                            }

                            if (isEmailValidation) {
                                if (!data.valid) {
                                    addEmailValidationErrors(data);
                                } else {
                                    clearEmailValidationErrors();
                                }
                            }
                        },
                        error: () => {
                            clearAutoComplete();
                            clearEmailValidationErrors();
                        },
                    });
                }, 300);
            });

            $emailInput.on('blur', () => {
                const email = $emailInput.val();

                if (skipBlur || email.length < 1) {
                    return;
                }

                triggerEmailValidation(email);
            });

            $emailValidation.on('mousedown', '.js-auto-complete-email-button', (e) => {
                skipBlur = true;

                const $target = $(e.currentTarget);
                const email = $target.attr('data-auto-complete-email');

                $emailInput.val(email);
                clearAutoComplete();
                clearEmailValidationErrors();
                triggerEmailValidation(email);

                setTimeout(() => {
                    skipBlur = false;
                }, 1000);
            });

            $emailConfirmCheckbox.on('change', (e) => {
                const $checkbox = $(e.currentTarget);
                const $checkboxRow = $checkbox.closest('.checkbox-row');

                if ($checkbox.is(':checked')) {
                    $checkboxRow.removeClass('is-invalid');
                } else {
                    $checkboxRow.addClass('is-invalid');
                }
            });
        };

        /**
         * Handles add club to the cart
         */
        function addClubBtn() {
            $(document).on('click', '.js-select-club-new-checkout', e => {
                e.preventDefault();
                e.stopPropagation();

                const $selectClubButton = $(e.currentTarget);
                const data = [];
                const pid = $selectClubButton.data('pid');
                const name = $selectClubButton.data('name').trim();
                const address1 = $selectClubButton.data('address1') || '';
                const address2 = $selectClubButton.data('address2') || '';
                data.unshift(name);
                window.localStorage.setItem('clubData',data.join("|"));
                const selectUrl = $('.js-stores-pagination').data('select-url');
        	    const addUrl = appendToUrl(selectUrl, { itemAdded: 'club' });

                if (addUrl) {
                    $.ajax({
                        url: addUrl,
                        method: 'POST',
                        data: {
                            pid: pid
                        },
                        success: data => {
                            if (!data.error) {
                                updateUrl(1);
                            } else {
                                let message = data.errorMessage ? data.errorMessage : data.error.errorText;
                                pushErrorEvent('checkout', message)
                            }

                            const $checkoutDataContainer = $('.js-data-checkout-stage');
                            const $clubSummaryInfo = $('.js-checkout-navigation__club-summary-info');
                            const $clubSummaryData = createStepOneClubSummary(address1, address2);
                            $clubSummaryInfo.empty();
                            $clubSummaryInfo.append($clubSummaryData);

                            updateMembershipBlock(data);
                            enableEditOfStep();

                            $('.js-choose-step-tab[data-stage="Membership"]').removeClass('disable-step');
                            $('.js-choose-step-tab[data-stage="Membership"]').next().removeClass('display-none');

                            // clean up modals step 1 if we came here through map modal or list modal:
                            $('.map-modal-veil').removeClass('active');
                            $('body').removeClass('no-scroll');

                            if ($('.mapboxgl-popup').length > 0) {
                                $('.mapboxgl-popup-close-button').trigger('click');
                            }
                            //  if the list modal was used
                            $('.checkout-navigation__tab-content-club.custom-popup').removeClass('custom-popup');
                            $('.js-in-tile-modal.show').removeClass('show');

                            //trigger additional click
                            $('.js-choose-step-tab[data-stage="Membership"]')
                                .find('.js-membership-table.highlighted .js-membership-btn-new')
                                .trigger('click');

                            //remove order summary if no membership plan is selected
                            $('.js-membership-table').each(function() {
                                if (!$(this).hasClass('active')) {
                                    showSummary(2);
                                }
                            });

                            stepAnimation('Membership');
                            updateUrl(1);
                            disableFutureSteps();
                            handleMembershipSelection();
                            equalizeTiles();
                            handleGtmEvent(1);

                            if (data.gtmClubDetails) {
                                const $tile = $selectClubButton.closest('.checkout-navigation__tab-content-club');
                                const details = typeof data.gtmClubDetails === 'string' ? JSON.parse(data.gtmClubDetails) : data.gtmClubDetails;
                                const type = $selectClubButton.data('type');
                                const view = $selectClubButton.data('view');
                                const position = view === 'list view' && $tile.length > 0 ? $tile.index() + 1 : null;

                                pushSelectClubEvent(details, type, view, position);
                                $checkoutDataContainer.data('gtm-club-details', data.gtmClubDetails);
                            }

                            if ($(window).width() < mobileMaxWidth) {
                                MembershipTiles.init();
                            }
                        },
                        error: (error) => {
                            let message = error.errorMessage ? error.errorMessage : error.error.errorText;
                            pushErrorEvent('checkout', message);
                            location.reload();
                        },
                    });
                }
            });
        }
        addClubBtn();

        /**
         * Updates the navigation at the top of the page based on the current stage
         * @param {number} currentStage - The current stage the user is currently on the checkout
         */
        function updateNavigation(currentStage) {
            const $navigation = $('.js-nav-tabs-sub-checkout');

            let navigationItems =  $navigation.find(".js-choose-step-tab");

            if (navigationItems) {
                for (let navigationItem of navigationItems) {

                    if($(navigationItem).data('stage') !== checkoutStages[currentStage]) {
                        $(navigationItem).removeClass('active');
                    }

                    if(!$(navigationItem).hasClass('active')) {
                        $(navigationItem).find('.js-summary-container').addClass('summary-display');
                    }
                }
            }

            let $currentNavigationItem = $navigation.find(`.js-choose-step-tab[data-stage="${checkoutStages[currentStage]}"]`);

            if(!$currentNavigationItem.hasClass('active')) {
                $currentNavigationItem.addClass('active');
            }
            $currentNavigationItem.find('.js-summary-container').removeClass('summary-display');

            //when clicking on membership button proceed to third step
            if ($('.js-choose-step-tab[data-stage="Membership"]').hasClass('active')) {
                equalizeTiles();

                // on refresh reinit slider
                if($(window).width() < mobileMaxWidth) {
                    if($('.js-membership-swiper').hasClass('swiper-container-initialized')) {
                        return;
                    } else {
                        MembershipTiles.init();
                    }
                }

                //if we select membership on PDP and come to new checkout remove default highlighed class
                $('.js-membership-table').each(function() {
                    if($(this).hasClass('active')) {
                        $('.js-membership-table.highlighted').removeClass('highlighted');
                    }
                });

                $('.js-choose-step-tab[data-stage="Membership"]')
                    .find('.js-membership-table.highlighted .js-membership-btn-new')
                    .trigger('click');
            }

            if ($('.js-choose-step-tab.active').data('id') === 2 && $('.js-checkout-navigation__membership-summary-info').children().length === 0) {
                ++isStep2;
                if (isStep2 === 1) {
                    // getAddOns();
                    updateMiniCart();
                    ++isStep3;
                }
            }

            $('.js-membership-table.active .btn--secondary').each(function () {
                $(this).on('click', () => {
                    ++isStep3;
                    if (isStep3 === 1) {
                        // getAddOns();
                        //apply show summary only on tablet/mobile view
                        bindOrderSummaryToggleTouchDevices();
                    }
                });
            });

            //reset padding value when order summary is hidden
            if($('.js-choose-step-tab[data-stage="HomeClub"].prev-step').hasClass('active')) {
                //make second step unavailable
                setTimeout(function() {
                    $('.js-choose-step-tab[data-stage="Membership"]').removeClass('prev-step');
                }, 10);
            };

            $('.js-choose-step-tab[data-stage="Membership"] .checkout-navigation__edit-btn').on('click', function() {
                $('.js-checkout-navigation__membership-summary-info').empty();
                $('.js-checkout-navigation__addons-container').empty();
                $('.js-checkout-order-summary').unbind('click');
                updateUrl(1);
                bindOrderSummaryToggleTouchDevices();
                isStep3 = 0;
                // animation to step 2:
                stepAnimation('Membership');
            });

            $('.js-choose-step-tab[data-stage="PersonalInformation"] .checkout-navigation__edit-btn').on('click', function() {
                $('.js-checkout-navigation__personal-info-summary-info').empty();
                $('.js-payment-summary-new').empty();
                bindOrderSummaryToggleTouchDevices();
            });

            if(!$('.js-choose-step-tab[data-stage="PaymentMethod"]').hasClass('active')) {
                $('.js-payment-summary-new').empty();
            }
            if(
                ($('.js-choose-step-tab[data-stage="PaymentMethod"]').hasClass('active') ||
                $('.js-choose-step-tab[data-stage="PersonalInformation"]').hasClass('active') ||
                $('.js-choose-step-tab[data-stage="AddOns"]').hasClass('active') ||
                $('.js-membership-table').hasClass('active'))
                &&
                (!$('.js-choose-step-tab[data-stage="HomeClub"]').hasClass('active'))
            ) {
                if($(window).width() > laptopMaxWidth) {
                    updateMiniCart();
                    // show order summary
                    showSummary(3);
                }

                setTimeout(function() {
                    // waiting after refresh for cart updates and ajax
                    if($(window).innerWidth() < laptopMaxWidth) {
                        showSummary(3);
                    }
                    bindOrderSummaryToggleTouchDevices();
                }, 500);
            }

            headerCheckoutProgress();
        }

        /**
         * Update contract length block on step 5
         * @param {string} chosenPlan - choosen plan
         * @param {string} contractLength - contract length
         */
        function updateContractLengthBlock(chosenPlan, contractLength) {
            const isAllIn = chosenPlan && chosenPlan.indexOf('All-In') > -1;
            const isFlex = chosenPlan && chosenPlan.indexOf('Flex') > -1;
            const is52Weeks = contractLength && contractLength === '52 weeks';
            const $contractLengthBlock = $('.js-payment-schedule.52weeks');
            const $subText = $('.js-payment-schedule').find('.sub-text');

            if (!isAllIn && is52Weeks) {
                $contractLengthBlock.removeClass('d-none');
            } else {
                $contractLengthBlock.addClass('d-none');
            }

            if (isFlex) {
                $subText.addClass('d-none');
            } else {
                $subText.removeClass('d-none');
            }
        }

        /**
         * Gets addOns data
        */
        function getAddOns() {
            const addOnsUrl = $('.js-get-addons-url').val();
            const preselectedMembershipInfo = getPreselectedMembershipInfo();
            const checkedPlanDuration = preselectedMembershipInfo && preselectedMembershipInfo.duration;
            const checkedPlan = preselectedMembershipInfo && preselectedMembershipInfo.name;
            const url = appendToUrl(addOnsUrl, {
                checkedPlanDuration,
                checkedPlan,
            });

            $('.js-checkout-navigation__addons-container').loader().start();

            $.ajax({
                url,
                method: 'GET',
                success: (data) => {
                    if (data.error) {
                        $('.js-checkout-navigation__addons-container').loader().stop();
                        return;
                    }

                    const $checkoutDataContainer = $('.js-data-checkout-stage');
                    if ($checkoutDataContainer.length && $checkoutDataContainer.length > 0) {
                        if (data.gtmSubscriptionOption) {
                            $checkoutDataContainer.data('gtm-subscription-option', data.gtmSubscriptionOption);
                        }
                    }

                    createMembershipSummary(data.chosenPlan);
                    $('.js-checkout-navigation__addons-container').empty();
                    $('.js-checkout-navigation__addons-container').append(data.addOnsHtml);
                    $('.js-checkout-navigation__addons-title').html(data.addonsIntroTitle);
                    updateContractLengthBlock(data.chosenPlan, data.membershipContractLength);
                    updateMembershipDuration(data.membershipDurationPlanHTML);
                    addOnCheckboxes();
                    selectMembership();
                    $('.js-checkout-navigation__addons-container').loader().stop();
                },
                error: () => {
                    $('.js-checkout-navigation__addons-container').loader().stop();
                },
            });
        }

        /**
         * Adds or removes add-on to the cart
         * @param {string} addOnId - Add-on id
         * @param {string} url - URL
         * @param {string} name - Add-on name
         * @param {boolean} isSelected - True if add-on is selected, False otherwise
         */
        function addOnActionInCart(addOnId, url, name, isSelected) {
            const form = {
                pid: addOnId,
                quantity: 1,
            };

            $.ajax({
                url,
                method: 'POST',
                data: form,
                success: data => {
                    if (!data.error) {
                        const $checkoutDataContainer = $('.js-data-checkout-stage');
                        updateMiniCart();

                        if (data.gtmProducts) {
                            $checkoutDataContainer.data('gtm-products', data.gtmProducts);
                        }

                        if (data.gtmProductsNew) {
                            const products = typeof data.gtmProductsNew === 'string' ? JSON.parse(data.gtmProductsNew) : data.gtmProductsNew;
                            pushSelectAddonEvent(products, name, isSelected);
                            $checkoutDataContainer.data('gtm-membership-products', data.gtmProductsNew);
                        }
                    }
                },
                error: () => {
                    $.spinner().stop();
                },
            });
        }

        /**
         * Handles add-on button click
         * @param {HTMLElement} addOnChbx - Add-on HTML element
         */
        function addRemoveAddOnFromCart(addOnChbx) {
            const checkedAddOn = $(addOnChbx[0]);
            const pid = checkedAddOn.data('pid');
            const name = checkedAddOn.data('default-name');
            const isSelected = checkedAddOn.is(':checked');
            const url = isSelected
                ? checkedAddOn.data('add-product-url')
                : checkedAddOn.data('remove-product-url');

            addOnActionInCart(pid, url, name, isSelected);
        }

        /**
         * @description Function for creating summary for addOns step
         * @params {Object} $addOnsSummary wrapper
         */
        function createAddOnsSummary($addOnsSummary) {
            let noAddOnsSelected = true;
            $('.js-subscription-addon-cta:checked').each(function(i, item) {
                const $this = $(this);
                if ($this.is(':checked')) {
                    $addOnsSummary.append(`
                        <div class="checkout-navigation__addons-summary-content">
                            <span> ${i === 0 ? '' : '+'} ${$this.data('title')}</span>
                        </div>
                    `);
                    noAddOnsSelected = false;
                }
            });
            if (noAddOnsSelected) {
                const noAddOnsMsg = $addOnsSummary.data('no-addons-msg');
                $addOnsSummary.append(`
                    <div class="checkout-navigation__addons-summary-content">
                        <span>${noAddOnsMsg}</span>
                    </div>
                `);
            }
        }

        /**
         * @description Function for creating summary for membership step
         * @param {string} chosenPlan - chosen plan
         */
        function createMembershipSummary(chosenPlan) {
            const $membershipSummary = $('.js-checkout-navigation__membership-summary-info');
            const $selectedDuration = $('.js-selected-duration');
            const $promosList = $('.js-membership-duration-wrapper.active p.checkout-navigation__year-promo-text');
            const promosTextList = [];
            let filteredPromosTextList = [];
            if ($promosList.length !== 0) {
                $promosList.each(function (i, promo) {
                    promosTextList.push($(promo).text().replace(/[\n\t\r]/g,""));
                });
            }
            promosTextList.forEach((element) => {
                if (!filteredPromosTextList.includes(element)) {
                    filteredPromosTextList.push(element);
                }
            });
            $membershipSummary.empty();
            let membershipName = $('.js-membership-btn-clicked').data('membership-name');
            const isSelectedDuration = $selectedDuration.data('duration');
            let membershipPlan;
            if (!isSelectedDuration) {
                membershipName = $('.js-membership-table.active').data('membership-name');
                membershipPlan = $('.js-membership-table.active input:checked').data('duration');
            } else {
                membershipPlan = $selectedDuration.data('duration');
            }
            const membershipSummaryTemplate =
                `<div class="properties">
                        <span class="plan js-selected-plan" data-chosenplan="${chosenPlan}">${chosenPlan || ''}</span>
                 </div>
                `;
            $membershipSummary.append(membershipSummaryTemplate);
            sessionStorage.setItem('membershipSummaryTemplate', membershipSummaryTemplate);
            $('.js-choose-step-tab[data-stage="Membership"]').addClass('prev-step');

            // animate after injection:
            // animation to step 3:
            stepAnimation('AddOns');
        }

        /**
         * Idetify user for Tracedock
         * @param {String} id - User id
         */
        function tracedockIdentify(id) {
            window.dataLayer.push({userId: id});
        }

        /**
         * Invokes GTM event helper functions
         * @param {number} currentStage - Checkout stage the user is currently on
         */
        function handleGtmEvent(currentStage) {
            const $checkoutDataContainer = $('.js-data-checkout-stage');
            const gtmProductsNew = $checkoutDataContainer.data('gtm-membership-products');
            const pageView = $checkoutDataContainer.data('gtm-page-view');
            const products = typeof gtmProductsNew === 'string' ? JSON.parse(gtmProductsNew) : gtmProductsNew;
            const originalLocation = document.location.protocol + '//'
                + document.location.hostname
                + document.location.pathname
                + document.location.search;

            pageView.location = window.location.href;
            pageView.title = $('title').text();

            tracedockIdentify($checkoutDataContainer.data('userid'));
            pushOriginalLocation(originalLocation);
            pushPageView(pageView);

            if (checkoutStages[currentStage] === 'PersonalInformation') {
                pushPersonalInformationEvent(products);
            }

            if (checkoutStages[currentStage] === 'PaymentMethod') {
                pushPaymentMethodEvent(products);
            }
        }

        /**
         * Updates the URL to determine stage
         * @param {number} currentStage - Checkout stage the user is currently on
         */
        function updateUrl(currentStage) {
            let url = `${location.pathname}?stage=${checkoutStages[currentStage]}`;
            const searchterm = $('input[name=searchterm]').val() || '';
            const filters = $('.js-search-filters').attr('data-selected-filters') || '';
            const searchParams = new URLSearchParams(window.location.search);
            const latitude = searchParams.get('latitude');
            const longitude = searchParams.get('longitude');
            const isLocation = searchParams.get('location') === 'true';
            const s = searchParams.get('s');
            const sz = searchParams.get('sz');

            if (searchterm) {
                url += `&searchterm=${searchterm}`;
            }
            if (filters) {
                url += `&filters=${filters}`;
            }
            if (latitude) {
                url += `&latitude=${latitude}`;
            }
            if (longitude) {
                url += `&longitude=${longitude}`;
            }
            if (isLocation) {
                url += `&location=${isLocation}`;
            }
            if (s) {
                url += `&s=${s}`;
            }
            if (sz) {
                url += `&sz=${sz}`;
            }

            history.pushState(checkoutStages[currentStage], document.title, url);
            updateNavigation(currentStage);

            if (members.currentStage !== 0) {
                const $orderTotalSummaryWrapper = $('.js-checkout-order-summary');
                $orderTotalSummaryWrapper.empty();
                $orderTotalSummaryWrapper.append(sessionStorage.getItem('miniCartTemplate') || '<div></div>');
            }

            enableEditOfStep();
        }

        /**
        * Follows checkout progress inside of header
        */
        function headerCheckoutProgress() {
            const checkoutTabs = document.querySelectorAll('.js-choose-step-tab');
            const checkoutHeaderSteps = document.querySelectorAll('.js-header-checkout-step');

            let activeItemId;

            checkoutTabs.forEach((item) => {
                item.classList.contains('active') ? activeItemId = item.getAttribute('data-id') : '';
            });

            checkoutHeaderSteps.forEach((item, index) => {
                if(index === +activeItemId) {
                    item.classList.add('active');
                    item.setAttribute('aria-selected', 'true');
                    item.previousElementSibling ? item.previousElementSibling.classList.add('prev-header-step') : '';
                } else {
                    item.classList.remove('active');
                    item.setAttribute('aria-selected', 'false');
                }
            });

            $('.js-header-checkout-step.active').nextAll().each(function() {
                $(this).removeClass('prev-header-step');
            });

            $('.js-header-checkout-step.active').prevAll().each(function() {
                $(this).addClass('prev-header-step');
            });
        }

        /**
        * On tab change refreshing checkout progress
        */
        function onTabChange() {
            const navigationTabs = document.querySelectorAll('.js-choose-step-tab');
            const headerTabs = document.querySelectorAll('.js-header-checkout-step');

            navigationTabs.forEach(navigationTab => {
                navigationTab.addEventListener('click', () => {
                    members.currentStage = navigationTab.getAttribute('data-id');
                    headerCheckoutProgress();
                });
            });

            headerTabs.forEach(headerTab => {
                headerTab.addEventListener('click', () => {
                    const $checkoutDataContainer = $('.js-data-checkout-stage');
                    const dataStage = headerTab.getAttribute('data-stage');
                    const currentStage = headerTab.getAttribute('data-id');
                    const activeTab = Array.from(headerTabs).find((currentTab) => currentTab.classList.contains('active'));
                    const activeStage = activeTab.getAttribute('data-stage');
                    const gtmProductsNew = $checkoutDataContainer.data('gtm-membership-products');
                    const products = typeof gtmProductsNew === 'string' ? JSON.parse(gtmProductsNew) : gtmProductsNew;

                    members.currentStage = currentStage;

                    if (dataStage === 'HomeClub') {
                        showSummary(1);
                    }

                    if ((dataStage === 'HomeClub' || dataStage === 'Membership') && activeStage === 'AddOns') {
                        pushRemoveFromCartEvent(products, false, true);
                    }

                    if ((dataStage === 'HomeClub' || dataStage === 'Membership') && (activeStage === 'PersonalInformation' || activeStage === 'PaymentMethod')) {
                        pushRemoveFromCartEvent(products, false, false);
                    }

                    if (dataStage === 'AddOns' && (activeStage === 'PersonalInformation' || activeStage === 'PaymentMethod')) {
                        pushRemoveFromCartEvent(products, true, false);
                    }

                    updateUrl(currentStage);
                    stepAnimation(dataStage);
                    headerCheckoutProgress();
                });
            });
        }

        // Modals moved all modals from step 2 outside
        function stepModals() {
            $('body').on('click', '.js-see-details', (e) => {
                const $target = $(e.target);
                const membershipTable = $target.parents('.js-membership-block[data-name]');

                if (membershipTable) {
                    pushMembershipViewDetailsEvent(membershipTable.data('name') || '');
                }
            });

            $('body').on('click', '.js-hide-details', (e) => {
                const $target = $(e.target);
                const membershipTable = $target.parents('.js-membership-block[data-name]');

                if (membershipTable) {
                    pushMembershipHideDetailsEvent(membershipTable.data('name') || '');
                }
            });

            $('body').on('click', '.js-tooltip-modal-all-in-icon', () => {
                $('.js-all-in-popup').addClass('show');
                $('body').addClass('popup-overlay');
            });

            $('body').on('click', '.js-addon-popup-btn', e => {
                const $target = $(e.target);
                $target.next().addClass('show');
                $('.js-all-in-popup').addClass('show');
                $('body').addClass('popup-overlay');
            });

            $('body').on('click', e => {
                const $target = $(e.target);
                // close modals; click anywhere in the body, besides here:
                if (
                    !$target.parents().is('.js-addon-popup') &&
                    !$target.parents().is('.js-all-in-popup') &&
                    !$target.parents().is('.tt-modal') &&
                    !$target.is('.tt-modal') &&
                    !$target.is('.js-tooltip-modal-icon') &&
                    !$target.is('.js-addon-popup') &&
                    !$target.is('.js-addon-popup-btn') &&
                    !$target.is('.js-all-in-popup') &&
                    !$target.is('.js-membership-contract-length') &&
                    !$target.is('.js-tooltip-modal-all-in-icon')
                ) {
                    if ($('body').find('.js-all-in-popup').hasClass('show')) {
                        pushMembershipHideDetailsEvent('all-in');
                    }

                    $('body').find('.js-addon-popup').removeClass('show');
                    $('body').find('.js-all-in-popup').removeClass('show');
                    $('body').removeClass('popup-overlay');
                }

                // close buttons
                if ($target.is('.js-addon-popup-close')) {
                    $('body').find('.js-addon-popup').removeClass('show');
                    $('body').removeClass('popup-overlay');
                }
                if ($target.is('.js-all-in-close-popup')) {
                    $('body').find('.js-all-in-popup').removeClass('show');
                    $('body').removeClass('popup-overlay');
                    pushMembershipHideDetailsEvent('all-in');
                }

                if (!$target.is('.js-auto-complete-email-list')) {
                    const $autoCompleteEmailList = $('body').find('.js-auto-complete-email-list');
                    $autoCompleteEmailList.remove();
                }
            });
        }

        // Addon checkboxes: Visuals; clicking the checkmark, price title or info modal button, will (un)check the addon and change texts in that button
        // note: js-subscription-addon-cta is bound elsewhere to add/remove from cart
        function addOnCheckboxes() {
            const $realCheckBox = $('.js-subscription-addon-cta');
            const $addonsTitles = $('.checkout-navigation__addon-title');
            const $addonsPrices = $('.checkout-navigation__addon-container .card__price-wrapper > .card__price');
            const $addonsModalButtons = $('.btn-modal-check');

            // Toggle active class on click
            $realCheckBox.each(function() {
                const $checkItem = $(this);
                const $tileBlock = $checkItem.closest('.js-checkout-addon');

                // Find the related button and toggle text
                const $modalButton = $tileBlock.find('.btn-modal-check');

                if ($tileBlock.hasClass('active')) {
                    toggleButtonText($modalButton, "active");
                }

                if (!$checkItem.data('bound')) {
                    $checkItem.on('click', function() {
                        $tileBlock.toggleClass('active');

                        if ($modalButton.length) {
                            toggleButtonText($modalButton);
                        }
                    });
                    $checkItem.data('bound', true); // Mark as bound
                }
            });

            function handleAddonClick($element) {
                if (!$element.data('bound')) {
                    $element.on('click', function() {
                        const $tileBlock = $element.closest('.js-checkout-addon');
                        const $realCheckBox = $tileBlock.find('.js-subscription-addon-cta');
                        $realCheckBox.trigger('click');
                    });
                    $element.data('bound', true); // Mark as bound
                }
            }

            // swapping real button text in modal button to make things A11y compliant
            function toggleButtonText($button, state = "toggle") {
                let defaultText = $button.data('default-text') || $button.text().trim(); // Get or store default text
                let selectedText = $button.attr('data-selected-text-swap'); // Get selected text from data attribute

                if (!$button.data('default-text')) {
                    $button.data('default-text', defaultText);
                }

                // If activating, assume the texts were previously switched
                if (state === "active") {
                    $button.text(selectedText);
                    $button.data('default-text', selectedText); // Store the reversed state
                    $button.attr('data-selected-text-swap', defaultText);
                }
                // If deactivating, restore the original texts
                else if (state === "inactive") {
                    $button.text(defaultText);
                    $button.data('default-text', defaultText);
                    $button.attr('data-selected-text-swap', selectedText);
                }
                // Default toggle behavior
                else {
                    const isSelected = $button.text().trim() === defaultText;
                    $button.text(isSelected ? selectedText : defaultText);
                    $button.data('default-text', isSelected ? selectedText : defaultText);
                    $button.attr('data-selected-text-swap', isSelected ? defaultText : selectedText);
                }
            }

            $addonsTitles.each(function() {
                handleAddonClick($(this));
            });

            $addonsPrices.each(function() {
                handleAddonClick($(this));
            });

            $addonsModalButtons.each(function() {
                handleAddonClick($(this));
            });
        }

        // membership table highlighting and select membership btn:
        function selectMembership() {
            const membershipBtns = document.querySelectorAll('.js-membership-btn');
            const membershipTables = document.querySelectorAll('.js-membership-table');


            membershipBtns.forEach((item) => {
                item.addEventListener('click', function() {
                    showSummary(1);

                    //remove active from all tables
                    membershipTables.forEach((item) => {
                        item.classList.remove('active');
                        item.classList.remove('highlighted');
                    });

                    //add active to the currently selected one
                    item.closest('.js-membership-table').classList.add('active');
                });
            });
        }

        /**
        * Open tabs function
        */
        openTabs(
            document.querySelectorAll('.js-choose-step-tab'),
            document.querySelectorAll('.js-choose-step-tab-content')
        );

        /**
        * Show details of the specific club
        */
        function showDetailsOfClub() {
            $(document)
            .on('click', '.js-btn-show-details', (e) => {
                // open in-tile-modal:
                e.currentTarget.parentElement.nextElementSibling.classList.toggle('show');
                document.querySelector('body').classList.add('no-scroll');
                //remove popup class from other clubs
                document.querySelectorAll('.checkout-navigation__tab-content-club').forEach(item => {
                    item.classList.remove('custom-popup');
                });
                // add class to this club tile
                e.currentTarget.closest('.checkout-navigation__tab-content-club').classList.add('custom-popup');
            })
            .on('click', '.js-tab-content-tile-close, .js-tab-content-back', (e) => {
                e.currentTarget.closest('.checkout-navigation__tab-content-club').classList.remove('custom-popup');
                e.currentTarget.closest('.checkout-navigation__tab-content-club').querySelector('.js-in-tile-modal').classList.remove('show');
                document.querySelector('body').classList.remove('no-scroll');
            });
        }

        /**
        * Edit of the step
        */
        function enableEditOfStep() {
            const summaryContainers = $('.js-summary-container');

            summaryContainers.each(function() {
                if($(this).children().length === 0) {
                    $(this).closest('.checkout-navigation__tab').removeClass('prev-step');
                } else {
                    $(this).closest('.checkout-navigation__tab').addClass('prev-step');
                }
            });

            $('.js-choose-step-tab.prev-step .checkout-navigation__edit-btn').each(function() {
                $(this).off('click').on('click', function(e) {
                    let stepId = $(e.currentTarget).closest('.js-choose-step-tab').attr('data-id');
                    let dataStage = $(e.currentTarget).closest('.checkout-navigation__tab').attr('data-stage')
                    // update history and URL
                    updateUrl(stepId);
                    // animation to all steps through edit button
                    stepAnimation(dataStage);
                    disableFutureSteps();
                    //apply show summary only on tablet/mobile view
                    bindOrderSummaryToggleTouchDevices();
                    updateMiniCart();
                    members.stepRebinder();
                });
            });
        }

        /**
         * Update peopleId and orderId input fields for Adyen Dropin
         * @param {Object} data - payload after submit of step 4 (Customer Info)
         */
        function updateAdyenInputFields(data) {
            $('.js-order-id-input').val(data.adyenOrderNo);
            $('.js-people-id-input').val(data.adyenPeopleId);
            const adyenOrderNo = data.adyenOrderNo;
            const adyenPeopleId = data.adyenPeopleId;
            sessionStorage.setItem('adyenOrderNo', adyenOrderNo);
            sessionStorage.setItem('adyenPeopleId', adyenPeopleId);
        }

        /**
         * Function for creating summary for step 4 (Personal Info)
         * @param {Object} customerData - Customer data entered in the form
         */
        function createPersonalInfoSummary(customerData) {
            const $personalInfoSummaryWrapper = $('.js-checkout-navigation__personal-info-summary-info');
            const addressData = customerData && customerData.address;

            if (addressData) {
                $personalInfoSummaryWrapper.html(
                    `<div class="checkout-navigation__personal-info-summary-content">
                        <span>${addressData.firstName} ${addressData.lastName}</span>
                        <span>${addressData.street} ${addressData.houseNumber}</span>
                    </div>`);
            }

            updateNavigation();
            bindOrderSummaryToggleTouchDevices();
        }

        /**
         * Updates payment schedule block dinamically when landing on step 5 from step 4
         * @param {string} membershipLength - Membership contract length
        */
        function updatePaymentScheduleBlock(membershipLength) {
            if (membershipLength !== '52 weeks') {
                $('.js-payment-schedule.52weeks').addClass('d-none');
                $('#input-payment-schedule-52weeks').prop('checked', false);
                $('#input-payment-schedule-fourWeeks').prop('checked', true);
            } else {
                $('.js-payment-schedule.52weeks').removeClass('d-none');
            }

            $('.js-payment-schedule.fourWeeks').trigger('click');
        }

        handleMembershipSelection();

        $('body').on('click', '.js-subscription-addon-cta', e => {
            addRemoveAddOnFromCart($(e.currentTarget));
        });

        $('body').on('click', '.js-next-step', (e) => {
            e.stopPropagation();

            const $target = $(e.currentTarget);

            if ($target.hasClass('btn--disabled')) {
                return;
            }

            const $stepTabs = $('.js-choose-step-tab');
            const $stepTabAddons = $('.js-choose-step-tab[data-stage="AddOns"]');
            const $checkoutDataContainer = $('.js-data-checkout-stage');
            const gtmProductsNew = $checkoutDataContainer.data('gtm-membership-products');
            const products = typeof gtmProductsNew === 'string' ? JSON.parse(gtmProductsNew) : gtmProductsNew;
            const step = $stepTabAddons.data('id');

            $stepTabs.each((i, tab) => {
                const $tab = $(tab);
                $tab.removeClass('active');
            });

            $stepTabAddons.addClass('active');
            $stepTabAddons.removeClass('disable-step');
            $stepTabAddons.next().removeClass('display-none');

            updateUrl(step);
            bindOrderSummaryToggleTouchDevices();
            stepAnimation('AddOns');
            handleGtmEvent(2);
            pushMembershipStepCTAEvent();
            disableFutureSteps();
            getAddOns();
            pushAddToCartEvent(products, false, true);
        });

        $('body').on('click', '.js-addons-step-btn', e => {
            e.stopPropagation();

            const $addOnsSummary = $('.js-checkout-navigation__addons-summary-info');
            const $checkoutDataContainer = $('.js-data-checkout-stage');
            const gtmProductsNew = $checkoutDataContainer.data('gtm-membership-products');
            const products = typeof gtmProductsNew === 'string' ? JSON.parse(gtmProductsNew) : gtmProductsNew;

            $addOnsSummary.empty();
            $('.js-choose-step-tab[data-stage="AddOns"]').addClass('prev-step');
            $('.js-choose-step-tab[data-stage="PersonalInformation"]').addClass('active');
            $('.js-choose-step-tab[data-stage="PersonalInformation"]').removeClass('disable-step, prev-step');

            createAddOnsSummary($addOnsSummary);
            enableEditOfStep();
            disableFutureSteps();

            if ($addOnsSummary.children().length === 0) {
                $addOnsSummary.append('<div class="checkout-navigation__addons-summary-block"></div>');

                $('.js-choose-step-tab[data-stage="AddOns"]').addClass('prev-step');
                $('.js-choose-step-tab[data-stage="PersonalInformation"]').removeClass('disable-step, prev-step');
                $('.js-choose-step-tab[data-stage="PersonalInformation"]').addClass('active');
                disableFutureSteps();
            }

            updateUrl($('.js-choose-step-tab[data-stage="PersonalInformation"]').data('id'));
            stepAnimation('PersonalInformation');
            handleGtmEvent(3);
            pushAddToCartEvent(products, true, false);
        });

        $('body').on('click', '.js-payment-methods-list > li', () => {
            // eslint-disable-next-line no-inner-declarations
            function validator(isValid) {
                const flag = isValid;
                const issuerList = $('#issuerList');

                if (flag) {
                    issuerList.css('border', '1px solid red');
                    issuerList.css('background-color', '#ffe4df');
                } else {
                    issuerList.css('border', '1px solid black');
                    issuerList.css('background-color', 'transparent');
                }
            }

            const issuerName = $('#adyenIssuerName');
            const issuerList = $('#issuerList > option:first-child');

            if (issuerList.length) {
                setTimeout(() => {
                    if (issuerList.text() === issuerName.val()) {
                        validator(true);
                    } else {
                        validator(false);
                    }
                }, 100);
            }
        });

        $('body').on('click', '.paymentMethod:not(:first-child)', () => {
            if ($('#issuerList').hasClass('no-error')) {
                $('#issuerList').removeClass('no-error');
            }
        });

        $('#issuerList')
            .on('click', (e) => {
                $(e.currentTarget).toggleClass('no-error');
            })
            .on('blur', (e) => {
                $(e.currentTarget).toggleClass('no-error');
            })
            .on(('change'), (e) => {
                const issuerName = $('#adyenIssuerName');
                issuerName.attr('value', $('#issuerList').find(':selected').text());
                $(e.currentTarget).trigger('click');
                $(e.currentTarget).removeClass('no-error');
            });

        $('.js-choose-step-tab[data-stage="PaymentMethod"] .js-choose-step-tab-content').on('click', function(e) {
            if($(e.target).is('.js-sepa-payment-checkbox .checkbox')) {
                return;
            } else {
                e.stopPropagation();
            }
        });

        $('body').on('click', '.js-choose-step-tab[data-stage="HomeClub"] .checkout-navigation__edit-btn', (e) => {
            e.stopPropagation();
            showSummary(1);

            if($(window).width() < laptopMaxWidth) {
                //close opened popup when going back to edit step 1
                document.querySelectorAll('.checkout-navigation__tab-content-club, .js-in-tile-modal').forEach(item => {
                    item.classList.remove('custom-popup');
                    item.classList.remove('show');
                });
            }
        });

        // Show error message for IBAN field if length validation fails
        function onIBANChange() {
            $('.js-iban-input input').on('input focusout', function() {
                var $this = $(this);
                setTimeout(function() {
                    if($this.val().length === 0) {
                        $('.js-iban-input .invalid-feedback-iban').hide();
                        $('.js-iban-input .invalid-feedback').show();
                    } else if($this.hasClass('is-invalid')) {
                        $('.js-iban-input .invalid-feedback').hide();
                        $('.js-iban-input .invalid-feedback-iban').show();
                    } else if(!$this.hasClass('is-invalid')) {
                        $('.js-iban-input .invalid-feedback-iban').hide();
                    }

                }, 350);
            });
        }

        // GTM events
        $('body').on('click', '.checkout-navigation__edit-btn', (e) => {
            const currentStage = $(e.currentTarget).closest('.js-choose-step-tab').data('id');
            handleGtmEvent(currentStage);
        });

        (function validateEmailsMatch($) {
            const $email = $('.email-container input');
            const $emailContainer = $('.email-container');
            const $emailconfirm = $('.emailconfirm-container input');
            const $emailconfirmContainer = $('.emailconfirm-container');

            if ($emailContainer.hasClass('js-email-validation-version1') || $emailContainer.hasClass('js-email-validation-version2') || $emailContainer.hasClass('js-email-validation-version3')) {
                return;
            }

            $($email).add($emailconfirm).on('change', () => {
                if ($email.val() === $emailconfirm.val()) {
                    $emailconfirmContainer.removeClass('is-invalid');
                    $emailconfirm.removeClass('is-invalid');
                    $emailconfirmContainer.find('.invalid-feedback').html('');
                }
            });
        }(jQuery));

        headerCheckoutProgress();
        onTabChange();
        stepModals();

        // Local member methods of the Checkout plugin
        const members = {

            // initialize the currentStage variable for the first time
            currentStage: 0,

            /**
             * Set or update the checkout stage (AKA the shipping, billing, payment, etc... steps)
             * @returns {Object} a promise
             */
            updateStage() {
                let stage = checkoutStages[members.currentStage];
                const defer = $.Deferred(); // eslint-disable-line new-cap
                let $form;

                if (stage === 'PersonalInformation') {
                    $form = $('.js-personal-information-form');

                    $.ajax({
                        url: $form.attr('action'),
                        method: 'POST',
                        data: $form.serialize(),
                        success(data) {
                            if (data.error) {
                                let message = data.errorMessage ? data.errorMessage : data.error.errorText;
                                pushErrorEvent('checkout', message)
                                if (data.cartError) {
                                    window.location.href = data.redirectUrl;
                                    defer.reject();
                                } else if (data.fieldErrors && data.fieldErrors.length > 0) {
                                    data.fieldErrors.forEach((error) => {
                                        if (Object.keys(error).length) {
                                            loadFormErrors($form, error);
                                        }
                                    });
                                } else {
                                    defer.reject(data);
                                }
                            } else {
                                const $orderSummary = $('.js-checkout-order-summary');
                                const $annualPaymentScheduleWrapper = $('.js-payment-schedule.52weeks');
                                const membershipLength = data.membershipContractLength;
                                const priceCurrency = $('.js-card-plan-price .currency').html();
                                const $miniCartPrice = $('.js-checkout-navigation__order-membership-cost')
                                    .first()
                                    .html();
                                const $paymentSchedulePrice = $('.js-payment-schedule-checkbox-label')
                                    .first()
                                    .find('.js-price').addClass('label-price');
                                $paymentSchedulePrice.html($miniCartPrice);
                                // Add missing currency to the original price
                                $paymentSchedulePrice.find('.original-price .card__price').prepend('<span class="currency">'+ priceCurrency +'</span>');

                                if ($annualPaymentScheduleWrapper && $annualPaymentScheduleWrapper.length) {
                                    const totalDiscountedPrice = $('.checkout-navigation__order-total-year-price.discounted-price').first().html();
                                    const $annualDiscountedPrice = $annualPaymentScheduleWrapper.find('.discounted-price');

                                    if (totalDiscountedPrice && $annualDiscountedPrice && $annualDiscountedPrice.length) {
                                        $annualDiscountedPrice.html(totalDiscountedPrice);
                                    }
                                }

                                //On success ajax call activate step 5 and hide step 4
                                $('.js-choose-step-tab[data-stage="PersonalInformation"]').removeClass('active');
                                $('.js-choose-step-tab[data-stage="PersonalInformation"]').addClass('prev-step');
                                createPersonalInfoSummary(data);
                                $('.js-choose-step-tab[data-stage="PaymentMethod"]').addClass('active');
                                $('.js-choose-step-tab[data-stage="PaymentMethod"]').removeClass('disable-step');

                                $('.js-payment-summary-new').append($orderSummary
                                    .clone()
                                    .removeClass('js-checkout-order-summary checkout-order-summary-floating')
                                    .addClass('checkout-order-summary-static'));

                                updateAdyenInputFields(data);
                                adyenDropin();
                                bindOrderSummaryToggleTouchDevices();
                                updateMiniCart();
                                updatePaymentScheduleBlock(membershipLength);

                                members.currentStage = $('.js-choose-step-tab[data-stage="PaymentMethod"]').data('id');
                                stage = checkoutStages[members.currentStage];
                                updateUrl($('.js-choose-step-tab[data-stage="PaymentMethod"]').data('id'));

                                //apply show summary only on tablet/mobile view
                                bindOrderSummaryToggleTouchDevices();

                                // animation to step 5:
                                stepAnimation('PaymentMethod');

                                // GTM events
                                handleGtmEvent(4);
                            }
                        },
                        error(e) {
                            let message = e.errorMessage ? e.errorMessage : e.error.errorText;
                            pushErrorEvent('checkout', message)
                            return;
                        },
                    });
                }

                if (stage === 'PaymentMethod') {
                    bindOrderSummaryToggleTouchDevices();

                    $form = $('.js-payment-method-form');

                    $.ajax({
                        url: $form.data('action'),
                        method: 'POST',
                        data: $form.serialize(),
                        success(data) {
                            if (data.error) {
                                let message = data.errorMessage ? data.errorMessage : data.error.errorText;
                                pushErrorEvent('checkout', message)

                                if (data.cartError) {
                                    window.location.href = data.redirectUrl;
                                    defer.reject();
                                } else if (data.fieldErrors && data.fieldErrors.length > 0) {
                                    data.fieldErrors.forEach((error) => {
                                        if (Object.keys(error).length) {
                                            loadFormErrors($form, error);
                                        }
                                    });
                                    if($('.adyen-checkout__dropdown__element--active').length == 0) {
                                        $('.adyen-checkout__dropdown__button').trigger()
                                    }
                                } else {
                                    // go to appropriate stage and display error message
                                    defer.reject(data);
                                }
                            }
                        },
                        error(e) {
                            let message = e.errorMessage ? e.errorMessage : e.error.errorText;
                            pushErrorEvent('checkout', message)
                        },
                    });
                }

                return defer;
            },

            // Initialize the checkout stage.
            initialize() {
                // set the initial state of checkout
                members.currentStage = Math.max(checkoutStages.indexOf($('.js-data-checkout-stage').data('checkout-stage')), 0);
                $(plugin).attr('data-checkout-stage', checkoutStages[members.currentStage]);

                countdown();
                checkoutLocation();
                handleRedirectFromCDP();
                showDetailsOfClub();
                // TT step 1:
                promotionLabelTooltip();
                // TT step 2:
                infoTooltipModal('from-side');
                closeMapModal();
                highlightlabels();
                handleDropinButtons();
                handleEmailValidation();
                hideMobileKeyboardOnReturn('.checkout-navigation .js-search-input');
                // on (re)load pass current stage:
                disableFutureSteps($('.js-data-checkout-stage').data('checkout-stage'));
                // show the correct summary after load/refresh
                if(members.currentStage === 0) {
                    showSummary(1);
                } else if (members.currentStage === 1) {
                    showSummary(2);
                } else {
                    showSummary(3);
                }
                initSummaryAccordion();
                toggleMobileSummary();
                bindOrderSummaryLowEntryBarrierPopup();

                Validator.init(plugin, {
                    submitHandler() {
                        members.nextStage();
                    },
                });

                // remember stage (e.g. shipping)
                updateUrl(members.currentStage);

                // Listen for foward/back button press and move to correct checkout-stage
                $(window).on('popstate', (e) => {
                    // Back button when event state less than current state in ordered
                    // checkoutStages array.
                    if (e.state === null ||
                        checkoutStages.indexOf(e.state) < members.currentStage) {
                        members.handlePrevStage(false);
                    } else if (checkoutStages.indexOf(e.state) > members.currentStage) {
                        // Forward button  pressed
                        members.handleNextStage(false);
                    }
                });

                $(window).on('load', () => {
                    members.stepRebinder();

                    const searchParams = new URLSearchParams(window.location.search);
                    const stage = searchParams.get('stage');

                    if (stage === 'PaymentMethod') {
                        const adyenOrderNo = sessionStorage.getItem('adyenOrderNo') ? sessionStorage.getItem('adyenOrderNo') : '';
                        const adyenPeopleId = sessionStorage.getItem('adyenPeopleId') ? sessionStorage.getItem('adyenPeopleId') : '';
                        const adyenInputsdata = {
                            adyenOrderNo,
                            adyenPeopleId,
                        };

                        if (adyenInputsdata.adyenOrderNo !== '' && adyenInputsdata.adyenPeopleId !== '') {
                            updateAdyenInputFields(adyenInputsdata);
                        }

                        adyenDropin();

                        // Apply show summary only on tablet/mobile view
                        bindOrderSummaryToggleTouchDevices();
                    }
                });

                // Set the form data
                plugin.data('formData', formData);

                // GTM events
                handleGtmEvent(members.currentStage);

				// IBAN length error on step 5
				onIBANChange();
            },

            /**
             * The next checkout state step updates the css for showing correct buttons etc...
             */
            nextStage() {
                const promise = members.updateStage();

                promise.done(() => {
                    // Update UI with new stage
                    window.scrollTo(0,0);
                    members.handleNextStage(true);
                });

                promise.fail((data) => {
                    // show errors
                    if (data) {
                        if (data.errorStage) {
                            members.gotoStage(data.errorStage.stage);
                        }

                        if (data.errorMessage) {
                            $('.error-message').show();
                            $('.error-message-text').text(data.errorMessage);
                            pushErrorEvent('checkout', data.errorMessage)
                        }
                    }
                });
            },

            /**
             * The next checkout state step updates the css for showing correct buttons etc...
             *
             * @param {boolean} bPushState - boolean when true pushes state using the history api.
             */
            handleNextStage(bPushState) {
                if (members.currentStage < checkoutStages.length - 1) {
                    // move stage forward
                    members.currentStage++;

                    //
                    // show new stage in url (e.g.payment)
                    //
                    if (bPushState) {
                        updateUrl(members.currentStage);
                    }
                }

                // Set the next stage on the DOM
                $(plugin).attr('data-checkout-stage', checkoutStages[members.currentStage]);
            },

            /**
             * Previous State
             */
            handlePrevStage() {
                if (members.currentStage > 0) {
                    // move state back
                    members.currentStage--;
                    updateUrl(members.currentStage);
                }

                $(plugin).attr('data-checkout-stage', checkoutStages[members.currentStage]);
            },

            /**
             * Use window history to go to a checkout stage
             * @param {string} stageName - the checkout state to goto
             */
            gotoStage(stageName) {
                members.currentStage = checkoutStages.indexOf(stageName);
                updateUrl(members.currentStage);
                $(plugin).attr('data-checkout-stage', checkoutStages[members.currentStage]);
            },

            /**
             * meant to (re)init steps on refresh
             * case 0 is step 1, case 1 is step 2, etc.
             */
            stepRebinder() {
                // always (re)bind step 3
                addOnCheckboxes();
                // NOTE for backend later; the real cart isnt updated between step 3 and 4 and that can cause real issues after refresh

                switch (members.currentStage) {
                    case 4: // step 5 reinit
                        updateMiniCart();
                        break;
                    default: // default case or nothing
                }
            }
        };

        // Prevent blocking order summary open logic if clicked enywhere on the page
        $('body').on('click', function(e) {
            //apply show summary only on tablet/mobile view
            if($(window).innerWidth() < laptopMaxWidth) {
                $('.checkout-navigation > .js-checkout-order-summary .js-order-summary-btn, .js-order-close-btn').unbind('click');
            }
            bindOrderSummaryToggleTouchDevices();
        });

        $('#dropin-container').on('click', () => {
            const $ideal = $('.adyen-checkout__payment-method--ideal');
            const $sofort = $('.adyen-checkout__payment-method--directEbanking');
            const $holderName = $('.adyen-checkout__card-input--credit input[name="holderName"]');
            const $paymentMethods = [
                $('.adyen-checkout__payment-method--credit'),
                $('.adyen-checkout__payment-method--paypal'),
                $('.adyen-checkout__payment-method--applepay'),
                $('.adyen-checkout__payment-method--bizum'),
                $('.adyen-checkout__payment-method--ideal'),
                $('.adyen-checkout__payment-method--directEbanking'),
                $('.adyen-checkout__payment-method--bcmc')
            ];
            const isValid = $paymentMethods.some(($paymentMethod) => $paymentMethod.length > 0 && $paymentMethod.hasClass('adyen-checkout__payment-method--selected'));

            if (isValid) {
                toggleDropinButtons($paymentMethods);
            }

            if ($ideal.hasClass('adyen-checkout__payment-method--selected') || $sofort.hasClass('adyen-checkout__payment-method--selected')) {
                $holderName.removeAttr('required');
            }
        });

        $('.js-toggle-button-list').on('click', () => {
            const $mapboxWrapper = $('.js-mapbox-map-wrapper');
            const $stores = $('.js-stores-pagination');
            const $storesPaginationLinkContainer = $('.js-stores-pagination-link-container');
            const $thisButton = $('.js-toggle-button-list');
            const $otherButton = $('.js-toggle-button-map');
            const isComplete = $storesPaginationLinkContainer.attr('data-page-complete') === 'true';

            if (!$thisButton.hasClass('active')) {
                pushViewTypeSelectEvent('list');
            }

            $mapboxWrapper.hide();
            $stores.show();
            $thisButton.addClass('active');
            $otherButton.removeClass('active');

            if (!isComplete) {
                $storesPaginationLinkContainer.removeClass('display-none');
            }
        });

        $('.js-toggle-button-map').on('click', () => {
            const $mapboxWrapper = $('.js-mapbox-map-wrapper');
            const $stores = $('.js-stores-pagination');
            const $storesPaginationLinkContainer = $('.js-stores-pagination-link-container');
            const $noResultsWrapper = $('.js-no-results');
            const $thisButton = $('.js-toggle-button-map');
            const $otherButton = $('.js-toggle-button-list');
            const isMapActive = $mapboxWrapper.hasClass('mapboxgl-map');
            const hasResults = !$noResultsWrapper.is(':visible');

            if (!$thisButton.hasClass('active')) {
                pushViewTypeSelectEvent('map');
            }

            $thisButton.addClass('active');
            $otherButton.removeClass('active');
            $storesPaginationLinkContainer.addClass('display-none');

            if (!isMapActive) {
                MapboxCheckout.init(hasResults);
            }

            if (hasResults) {
                $stores.hide();
                $mapboxWrapper.show();

                if (window.mapboxMap) {
                    window.mapboxMap.resize();
                }
            } else {
                $mapboxWrapper.hide();
            }
        });

        $('form.input-wrapper').on('submit', e => {
            e.preventDefault();
            searchStores();
        });

        $('#js-btn-submit-search').on('click', e => {
            e.preventDefault();
            searchStores()
        });

        $('.js-filter-button').on('click', e => {
            e.preventDefault();

            const $filter = $(e.currentTarget);
            const isSelected = $filter.hasClass('selected');
            const filterId = $filter.data('id');
            const filterName = $filter.attr('name').toLowerCase();

            if (!isSelected) {
                $(document).trigger('subscriptionQuickLinkClicked', [filterId]);
            }

            $filter.toggleClass('selected');
            searchStores();
            pushSelectFilterEvent(filterName, isSelected);

            if (!isSelected && $('.js-mapbox-link').hasClass('map-active')) {
                $('.js-mapbox-link').trigger('click');
            }
        });

        $('.js-stores-pagination-link').on('click', () => {
            const $storesPaginationLinkContainer = $('.js-stores-pagination-link-container');
            const $storesPagination = $('.js-stores-pagination');
            const searchTerm = $('input[name=searchterm]').val();
            const filters = getSelectedFilters();
            const searchParams = new URLSearchParams(window.location.search);
            const latitude = searchParams.get('latitude');
            const longitude = searchParams.get('longitude');
            const action = $storesPaginationLinkContainer.attr('data-url');
            const s = $storesPaginationLinkContainer.attr('data-page-start');
            const sz = $storesPaginationLinkContainer.attr('data-page-size');
            const urlParameters = {
                s,
                sz,
                checkout: true,
                isLoadMore: true,
            };

            if (searchTerm) {
                urlParameters.searchterm = searchTerm;
            }
            if (filters) {
                urlParameters.filters = filters;
            }
            if (latitude) {
                urlParameters.latitude = latitude;
            }
            if (longitude) {
                urlParameters.longitude = longitude;
            }

            const url = appendToUrl(action, urlParameters);
            const scrollPosition = window.scrollY;

            $.ajax({
                url,
                type: 'GET',
                dataType: 'json',
                success: (data) => {
                    $storesPaginationLinkContainer.attr('data-page-start', data.pageStart);
                    $storesPaginationLinkContainer.attr('data-page-size', data.pageSize);
                    $storesPaginationLinkContainer.attr('data-page-complete', data.isComplete);

                    if (data.storesResultsHtml) {
                        $storesPagination.append(data.storesResultsHtml);
                        window.scrollTo(0, scrollPosition);
                    }

                    modifyUrl({
                        s: data.pageStart - data.pageSize,
                        sz: data.pageSize,
                    });

                    if (data.isComplete) {
                        $storesPaginationLinkContainer.addClass('display-none');
                    }
                },
            });
        });

        // Initialize the checkout
        members.initialize();

        return this;
    };
}(jQuery));

export default function initialize() {
    $('.js-checkout-main').checkout();
}
